import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const CompanyColumn = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { labelConfiguration, externalFulfillmentConfiguration } =
    useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) ?? {};

  const shipTo = labelConfiguration?.shipTo ?? externalFulfillmentConfiguration?.shipTo;

  const { company } = shipTo ?? {};

  return company;
};

CompanyColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const Company = {
  getMessageDescriptor: () => messages.company,
  id: 'company',

  render: (data) => {
    return <CompanyColumn fulfillmentId={data.id} />;
  },
};
